import {
  HOME_BEREICH_LABELS,
  type HomeBereich,
} from "@shared/home/rollen";

import { cn } from "@/lib/utils";

// ---------------------------------------------------------------------------
// ROLLE-1 — der Umschalter zwischen den Bereichen eines Menschen.
// ---------------------------------------------------------------------------
// Er sitzt im `eyebrow`-Platz der Kopfleiste, weil dort schon heute das
// Rollen-Wort steht («Projektleitung»). Wer zwei Huete traegt, findet die
// Umschaltung damit genau da, wo bisher stand, welchen er aufhat — kein
// zweiter Ort, keine zweite Sprache.
//
// Er rendert NUR bei mehr als einem Bereich. Fuer Corsin, Marvin, Jacqueline
// und Daniel aendert sich an der Kopfleiste damit kein Pixel.
//
// Bewusst keine Icons: die Kopfleiste traegt rechts schon den Zaehler-Streifen,
// und zwei Woerter sind hier die kuerzere Auskunft als zwei Sinnbilder, die
// man erst deuten muss.

export interface RollenUmschalterProps {
  readonly bereiche: readonly HomeBereich[];
  readonly aktiv: HomeBereich;
  readonly onWechsel: (bereich: HomeBereich) => void;
}

export function RollenUmschalter({
  bereiche,
  aktiv,
  onWechsel,
}: RollenUmschalterProps) {
  if (bereiche.length < 2) return null;

  return (
    <div
      className="flex items-baseline gap-1 text-xs"
      role="group"
      aria-label="Bereich der Startseite"
      data-testid="rollen-umschalter"
    >
      {bereiche.map((bereich) => {
        const istAktiv = bereich === aktiv;
        return (
          <button
            key={bereich}
            type="button"
            onClick={() => onWechsel(bereich)}
            aria-pressed={istAktiv}
            data-testid={`rollen-umschalter-${bereich}`}
            data-state={istAktiv ? "aktiv" : "inaktiv"}
            className={cn(
              "rounded-sm px-1.5 py-0.5 transition-colors",
              "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-topbar-foreground",
              istAktiv
                ? "font-semibold text-topbar-foreground"
                : "text-topbar-muted hover:text-topbar-foreground",
            )}
          >
            {HOME_BEREICH_LABELS[bereich]}
          </button>
        );
      })}
    </div>
  );
}
